export default __webpack_public_path__ + "static/media/Gujarat_1.62dd7fb5.png";